import { updateSession } from '../../lib/funnels/functions/v1/default/updateSession.js'
import { queryParamsToSession } from '../../lib/funnels/functions/v1/default/queryParamsToSession.js'

const SESSION_ID = 'dsaFunnel'
// funnel is served from the domain root in prod, but under /dsa locally
const BASE_PATH = window.location.hostname.includes('local') ? '/dsa' : ''

document.addEventListener('DOMContentLoaded', () => {
  queryParamsToSession(SESSION_ID)

  document.querySelectorAll('[data-debt]').forEach((btn) => {
    const anchor = /** @type {HTMLAnchorElement} */ (btn)
    anchor.addEventListener('click', (e) => {
      e.preventDefault()
      updateSession(SESSION_ID, 'debtOwed', anchor.dataset.debt || '')
      window.location.href = `${BASE_PATH}${anchor.getAttribute('href')}${window.location.search}`
    })
  })
})
